import { Component, Input, OnInit } from '@angular/core';
import { OrderService } from 'src/app/services/order.service';
import { saveAs } from 'file-saver';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FileService } from 'src/app/services/file.service';
import { CustomerInfoService } from 'src/app/services/customer-info.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomerService } from 'src/app/services/customer.service';
import { HttpResponse } from '@angular/common/http';
import * as JSZip from 'jszip';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
@Component({
  selector: 'delivery-history-component',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.less']
})



export class DeliveryHistoryComponent implements OnInit {
  @Input() tabSelectedIndex: number | undefined;
  searchFormData!: FormGroup;
  isDealerPortal: boolean = false;
  constructor(
    private orderService: OrderService,
    private fb: FormBuilder,
    private fileService: FileService,
    private commonService: CommonService,
    private customerInfoService: CustomerInfoService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private customerService: CustomerService,
    private sharedData: SharedDataService,
  ) { 
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
  }
  pagination = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    pageSizeOptions: [10, 20, 50],
  };
  isSpinning = true;
  exportLoading = false;
  sortList:any=[];
  codeTypeList:any=[];
  statusList:any=[];
  chartData:any=[];

  deliveryListData: Array<any> = [];
  shippingAddressList: Array<any> = [];
  firstLoading:boolean = true;
  isReset:boolean = false;


  ngOnInit(): void {
    this.updateData();
    this.translate.onLangChange.subscribe(() => {
      if(this.tabSelectedIndex==2 && !this.firstLoading){
        this.updateData();
        this.initData();
      }
    });
    this.route.queryParams.subscribe(params => {
      const tabSelectNumber = params['tabSelectNumber'];
      const dn_status = params['status'];
      let status: string[] = [];
      if (tabSelectNumber == 2) {
        status = dn_status?[dn_status]:['Pickpack', 'Pickpack done'];
      }
      this.searchFormData = this.fb.group({
        orderDate: [[], []],
        deliveryStatusList: [status, []],
        keywordsType: ['orderedMaterialNumber', []],
        keywords: ['', []],
        shipTo: [null, []],
        sortType: ['oidi.dn_no/desc', []],
      });
    })
    this.initData();
    this.firstLoading = false;
    this.customerService.selectedCustomer$.subscribe(() => {
      if(this.tabSelectedIndex==2 && !this.firstLoading){
       this.initData();       
      }
    });
  }
  initData():void{
    this.queryDeliveryList();
    this.queryOrderDeliveryStatistics();
    let param = {
      pageNum:1,
      pageSize:-1
    };
    this.customerInfoService.getShippingAddresses(param).subscribe(({ data }) => {
      this.shippingAddressList = data.records || [];
    })
  }

  clear():void{
    this.isReset = true;
    this.searchFormData.reset({
      orderDate: [],
      deliveryStatusList: [],
      keywordsType: 'orderedMaterialNumber',
      keywords: '',
      shipTo: null,
      sortType: 'oidi.dn_no/desc'
    });
    this.queryDeliveryList();
    this.isReset = false;
  }

  filterOption(input: string, option: any): boolean {
    const shippingAddress = option.nzValue;
    const customerCode = shippingAddress?.customerCode?.toLowerCase() || '';
    const street = shippingAddress?.street?.toLowerCase() || '';
    const customerName = shippingAddress?.customerName?.toLowerCase() || '';

    const search = input.toLowerCase();
    return customerCode.includes(search) || street.includes(search) || customerName.includes(search);
  };

  updateData():void{
    this.sortList =   [
      { name: this.translate.instant('DELIVERY_DATE_DESC'), value: 'oidi.dn_create_date/desc' },
      { name: this.translate.instant('DELIVERY_DATE_ASC'), value: 'oidi.dn_create_date/asc' },
      { name: this.translate.instant('DELIVERY_NO_ASC'),value: 'oidi.dn_no/asc' },
      { name: this.translate.instant('DELIVERY_NO_DESC'), value: 'oidi.dn_no/desc' },
      { name:this.translate.instant('ORDER_DESC'), value: 'oidi.order_no/desc' },
      { name: this.translate.instant('ORDER_ASC'), value: 'oidi.order_no/asc' },
    ];
this.codeTypeList=   [
      { name: this.translate.instant('BY_MATERIAL_NUMBER'), value: 'orderedMaterialNumber' },
      { name: this.translate.instant('BY_DELIVERY_NO'), value: 'dnNo' },
      { name: this.translate.instant('By_Bosch_Order_No'), value: 'orderNo' },
      { name: this.translate.instant('BY_CUSTOMER_PURCHASE_ORDER_NO'), value: 'poNo' },
      { name: this.translate.instant('BY_INVOICE_NUMBER'), value: 'billingNo'}
    ];
  this.statusList = [
      { name: this.translate.instant('CREDIT_BLOCKED'), value: 'Credit blocked' },
      { name: this.translate.instant('PICKPACK'), value: 'Pickpack' },
      { name: this.translate.instant('PICKPACK_DONE'), value: 'Pickpack done' },
      { name: this.translate.instant('GOODS_ISSUED'), value: 'Goods Issued' },
      { name: this.translate.instant('BILLING'), value: 'Billing' },
    ];
  this.chartData=  [
      { label: this.translate.instant('WAREHOUSE'), value: 0, color: '#F19F23',status:['Pickpack', 'Pickpack done']},
      { label: this.translate.instant('COMPLETED'), value: 0, color: '#18837E',status:['Goods Issued', 'Billing'  ] },
      { label: this.translate.instant('CREDIT_BLOCKED'), value: 0, color: '#9E2896',status:['Credit blocked'] },
    ];
  }

  /*
   ** change search filter,get list again
   */
  handleChange(e?: Event): void {
    if(!this.isReset){
      setTimeout(() => {
      this.pagination.pageIndex = 1;
      this.queryDeliveryList();
    },0)
    }
  }

  handleStatus(statusArr:string[], label:string):void{
  
    this.searchFormData.patchValue({
      deliveryStatusList: statusArr
    });

    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_order_quick_filter_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: "delivery status",
        event_name: 'order quick filter',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: statusArr,
      });
    }
   // this.handleChange();
  }

  goTracking(trackingNo:string):void{
    if (trackingNo.startsWith('SF')) {
      return;
    }
    const urlSuffix = `/l/bo_order_tracing_ext?no=${trackingNo}`;
    
    const targetUrl = environment.production
      ? `https://bosch.my.logwirecloud.com/#${urlSuffix}` // production
      : `https://nnbn--dev3-lz.dev3.logwirecloud.com/#${urlSuffix}`; // stage

    window.open(targetUrl, '_blank');
  }

  goPage(url: string, data: any): void {
    localStorage.removeItem("needRefresh");
    const country = localStorage.getItem("country");
    this.router.navigate([`${country}/${url}`], { queryParams: { orderNo: data } });
  }
  queryOrderDeliveryStatistics(): void {
    this.orderService.queryOrderDeliveryStatistics().subscribe((result) => {
      const { creditBlockedCount, inWarehouseCount, completedCount } = result.rtnData
      this.chartData[2].value = creditBlockedCount;
      this.chartData[0].value = inWarehouseCount;
      this.chartData[1].value = completedCount;
    });
  }


  /*
  ** get delivery data
  */
  async queryDeliveryList(): Promise<void> {
    this.isSpinning = true;
    const [sortType, ascType] = this.searchFormData.value.sortType.split('/');
    const dynamicObject: { [key: string]: string } = {
      [this.searchFormData.value.keywordsType]:
        this.searchFormData.value.keywords,
    };
    let params = {
      ...dynamicObject,
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
      endDate: this.searchFormData.value.orderDate
        ? this.commonService.formatDateString(this.searchFormData.value.orderDate[1]) ?? ''
        : '',
      beginDate: this.searchFormData.value.orderDate
        ? this.commonService.formatDateString(this.searchFormData.value.orderDate[0]) ?? ''
        : '',
      deliveryStatusStr: this.searchFormData.value.deliveryStatusList.join(','),
      shipTo: this.searchFormData.value.shipTo?.customerCode??'',
      column: sortType,
      order: ascType
    };
    await this.orderService.queryOrderDeliveryList(params).subscribe(({ rtnCode, rtnData }) => {
      if (rtnCode === 10000) {
        const { total, records } = rtnData
        this.pagination.total = total;
        this.deliveryListData = records || []
        this.isSpinning = false;
      }
    })
    if(environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      const keysString = Object.keys(params).join(',');
      const valuesString = Object.values(params)
        .map(value => {
          // 如果值是数组（如 orderType），先转为字符串，或者根据需求处理 null/undefined
          if (Array.isArray(value)) {
            return value.join('|'); // 数组内部建议用不同分隔符，以免混淆
          }
          return value ?? ''; // 处理 null 或 undefined
        })
        .join(',');
      (window as any).dataLayer.push({
        event: 'dp_delivery_detail_filter_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: keysString,
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: valuesString,
      });
    }
  }
  // pagination -- change pageIndex
  handleChangeCurrentPage(page: number): void {
    this.pagination.pageIndex = page;
    this.queryDeliveryList()
  }

  // pagination -- change pageSize
  handleChangePageSize(size: number): void {
    this.pagination.pageSize = size;
    this.pagination.pageIndex = 1;
    this.queryDeliveryList()
  }
  changeKeywords() {
    this.searchFormData.get('keywords')?.setValue('');
  }

  onInputEnter(event: any): void {
    event.preventDefault();
    this.queryDeliveryList();
  }

  getColorByStatus(status: string, isBackground: boolean, isBorder: boolean): string {
    let color = "";
    const processingStatuses = ['Pickpack', 'Pickpack done'];
    const completedStatus =  ['Goods Issued', 'Billing'];

    if (status === "Credit blocked") {
      color = isBackground ? "#F9F2F9" : (isBorder ? "#C279BE" : "#9E2896");
    } else if (processingStatuses.includes(status)) {
      color = isBackground ? "#FEF5E9" : (isBorder ? "#F6C172" : "#F19F23");
    } else if (completedStatus.includes(status)) {
      color = isBackground ? "#DEF5F3" : (isBorder ? "#84BDBA" : "#18837E");
    } else {
      color = isBackground ? "#F2F3F4" : (isBorder ? "#B2B9C0" : "#A0A0A0");
    }
    return color;
  }


  /*
  **  export delivery List 
  *
  */
  async exportExcel(): Promise<void> {
    this.exportLoading = true;
    const [sortType, ascType] = this.searchFormData.value.sortType.split('/');
    await this.fileService
      .exportToExcel(
        `/eshop_backend/orderItemDeliveryInfo/export?size=${this.pagination.pageSize}&current=${this.pagination.pageIndex}&endDate=${this.searchFormData.value.orderDate
          ? this.commonService.formatDateString(this.searchFormData.value.orderDate[1]) ?? ''
          : ''}&beginDate=${this.searchFormData.value.orderDate
            ? this.commonService.formatDateString(this.searchFormData.value.orderDate[0]) ?? ''
            : ''}&deliveryStatusStr=${this.searchFormData.value.deliveryStatusList.join(',')}&shipTo=${this.searchFormData.value.shipTo?.customerCode??''}&${this.searchFormData.value.keywordsType}=${this.searchFormData.value.keywords}&column=${sortType}&order=${ascType}`
      ).subscribe(async (response: HttpResponse<Blob>) => {
        // const contentDisposition = response.headers.get('Content-Disposition');
        // let fileName = `Delivery_History.zip`;
        // if (contentDisposition) {
        //   fileName = contentDisposition.split('fileName=')[1]?.split(';')[0]?.replace(/"/g, '');
        // }
        // const blob = new Blob([response.body!], {
        //   type: 'application/zip',
        // });
        // saveAs(blob, decodeURIComponent(fileName));
        const unzipped = await JSZip.loadAsync(response.body!); //  ZIP
        // map the unzip file
        for (const [filename, fileObj] of Object.entries(unzipped.files)) {
          if (filename.endsWith('.xlsx') || filename.endsWith('.xls')) {
            const excelData = await fileObj.async('blob'); // read as Blob
            saveAs(excelData, decodeURIComponent(filename));
          }
        }

        
        this.exportLoading = false;
      },
        (error: any) => {
          console.error('Error exporting Zip:', error);
        })
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_order_download_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: 'delivery status',
        event_name: 'order download',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: this.searchFormData.value.deliveryStatusList.join(','),
      });
    }
  }

}
